import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "../components/Typography";
import PublishingHeroLayout from "./PublishingHeroLayout";

export default function PublishingHero() {
  return (
    <React.Fragment>
      <PublishingHeroLayout>
        <Box
          sx={{
            textAlign: "center",
            color: "black",
            zIndex: 2,
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontWeight: 500,
              letterSpacing: "1px",
              mb: 2,
              fontSize: { xs: "2.5rem", sm: "3.75rem" },
            }}
          >
            PUBLISHING
          </Typography>
        </Box>
      </PublishingHeroLayout>
    </React.Fragment>
  );
}
